import React, { useState, useRef, useCallback, useMemo } from "react";
import { Icon, Style, Stroke } from "ol/style.js";
import { fromLonLat } from "ol/proj";
import { useGetDevicesTrackingQuery, useGetVariablesDataQuery } from "../services";
import { useGetVariablesQuery } from "../../Admin/services";
import { VehicleDetailsWindowView } from "../Vehicles/VehicleDetailsWindowView";
import { VehicleMap } from "../Vehicles/VehicleMap";
import { VehicleTrack } from "../Vehicles/VehicleTrack";
import { DeviceList } from "./DeviceList";
import { Dnd, MinimisedTab, useDndContainer, WindowTab } from "../Dnd";
import { locationImg, locArrowImg } from "../assets/mapIcons";
import { googleDirectionIcon } from "../googleDirectionIcon";
import { useEffect } from "react";
import { useWebSocket } from "../../../hooks";
import {
  QICustomDateRangePicker,
  QIDragAndDropDetails,
  QISwitch,
  QIAutoMapIndicator,
} from "../../../components";
import moment from "moment";
import { TripsContainer } from "../Vehicles/Trips";
import { EventsContainer } from "../Vehicles/Events";
//Data config json
import { HeaderDetails, ListDetails } from "../Shared/VehicleDetailsItems";
import { SelectedAssetSummary } from "../Shared";
import { LiveStatusIndicator } from "../Shared/LiveStatusIndicator";
//Toast Message
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startPointMarkerNew, direction, homeLocation, directionArrow } from "../assets";

//TrackPoints
import LiveTrackPoints from "../Vehicles/TrackPoints";
import { HistoryTrackPoints } from "../Vehicles/TrackPoints";

//Raw Data
import { RawData } from "../Vehicles/RawData";
//Trips
import Activities from "../Vehicles/Activities";
//Graphs
import { GraphsContainer } from "../Graphs";
import { useDispatch, useSelector } from "react-redux";
import {
  setVariableDatas,
  setCurrentTabGlobal,
  setGlobalResetCount,
  setLiveTrackData,
} from "../../../reduxStore/features";
import { getLocalizedString } from "../../../shared/translation";
import mapboxgl from "mapbox-gl";
import {
  debounce,
  getRotation,
  getRenderableTrackingPoints,
  getVehicleDeviceDataTimestamp,
  sortAndRemoveDuplicatesByTimestamp,
  selectLatestDeviceMovement,
  resolveTrackingStatus,
  MOVEMENT_STATUS_PRESENTATION,
  renderQiMapDeviceLabels,
  clearQiMapDeviceLabels,
  generateDirectionalArrowPoints,
} from "../utils";
import EventsMap from "../Events/EventMap";
import TripsMap from "../Trips/TripsMap";
import { HorizontalScroll } from "../Shared/HorizontalScroll";
import { useGetPluginsQuery } from "../../ManagementPortal/services";
import { PluginContainer } from "../../Plugins";
import { useMapClustering } from "../useMapClustering";
import {
  renderQiMapClusterMarkers,
  clearQiMapClusterMarkers,
  renderMapboxClusters,
  renderGoogleMapClusters,
} from "../clusterRenderers";
import { isCluster as isClusterFeature } from "../clusterUtils";
import {
  getMapViewport,
  getOverviewFitZoom,
  getVisibleClusters,
  selectOverviewPointsToDraw,
} from "../clusterUtils";
import {
  attachQiMapManualInteractionListeners,
  shouldAttachMapListeners,
} from "../mapViewportPolicy";
import { usePagination } from "../../../hooks";
import { removeDuplicates } from "../utils";

export const DeviceContainer = () => {
  const dispatch = useDispatch();
  let selectedRange = useSelector((state) => state.common.selectedRange);
  let globalResetCount = useSelector((state) => state.common.globalResetCount);
  let trackpointsSelectedRange = useSelector((state) => state.common.globalLiveLastDataTime);
  let configJson = useSelector((state) => state.common.globalCustomJson);
  let globalDockAlign = useSelector((state) => state.common.globalDockAlign);

  const [clientId, setClientId] = useState(null);
  const [mapProvider, setMapProvider] = useState();
  const [mapboxAccessToken, setMapBoxAccessToken] = useState();
  const [googleMapsApiKey, setGoogleMapsApiKey] = useState();
  const [mapRef, setMapRef] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [deviceData, setDeviceData] = useState(null);
  const [deviceId, setDeviceId] = useState(null);
  const [sourceIds, setSourceIds] = useState([]);
  const [count, setCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(0);
  const [mapData, setMapData] = useState({});
  const [trackingPoints, setTrackingPoints] = useState([]);
  const [selectedVehiclePlate, setselectedVehiclePlate] = useState(null);
  const [selectedDeviceName, setselectedDeviceName] = useState(null);
  const [highlight, setHighlight] = useState(null);
  const [dockAlign, setDockAlign] = useState(null);
  const [mapExpand, setMapExpand] = useState(false);
  const [showTrack, setShowTrack] = useState(false);
  const [trackMapRef, setTrackMapRef] = useState(null);
  const [simpleSearch, setSimpleSearch] = useState("");
  const [currentTab, setCurrentTab] = useState("Map");
  const [trackpointsHistoryData, setTrackpointsHistoryData] = useState([]);
  const [standstillData, setStandstillData] = useState([]);
  const [mapResetCount, setMapResetCount] = useState(1);

  const [selectedRangeHistory, setSelectedRangeHistory] = useState({
    startDate: moment().subtract(1, "hours"),
    endDate: moment(),
  });
  const [selectedRangeLive, setSelectedRangeLive] = useState({
    startDate: moment().subtract(trackpointsSelectedRange, "minutes"),
    endDate: moment(),
  });

  const [resetCount, setResetCount] = useState(0);
  const [selectedRowId, setSelectedRowId] = useState(null);
  // Config Set
  const [clientConfig, setClientConfig] = useState({});
  const [maximizeMinimize, setmaximizeMinimize] = useState(false);
  const [toggleTrackPointTab, setToggleTrackPointTab] = useState(false);
  const [decode, setDecode] = useState(false);
  const [order, setOrder] = useState(false);
  const [variableData, setVariableData] = useState({});
  const [variablePage, setVariablePage] = useState(0);
  const [vehicleData, setVehicleData] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true); // Flag to check if initial load
  const [mapPoint, setMapPoint] = useState(null);
  const [devicesData, setDevicesData] = useState([]); // Stores vehicles plate no and associated device imei
  const [sortedDataDisplay, setSortedDataDisplay] = useState(true);
  const [nonAdminUserId, setNonAdminUserId] = useState("");
  const [lastRefreshTime, setLastRefreshTime] = useState(Date.now());
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [liveTrackingData, setLiveTrackingData] = useState([]);
  const [selectedTrackPointData, setSelectedTrackPointData] = useState(null);
  const [liveDetailsBlockView, setLiveDetailsBlockView] = useState("TrackPoints");
  const [showEventsDetails, setShowEventsDetails] = useState(null);
  const [isTrackPointsHistoryDataCollected, setIsTrackPointsHistoryDataCollected] = useState(false);
  const [liveTime, setLiveTime] = useState();
  const [userHasAdjustedMap, setUserHasAdjustedMap] = useState(false);
  const [currentMapZoom, setCurrentMapZoom] = useState(null);
  const [currentMapCenter, setCurrentMapCenter] = useState(null);
  const [isInitialVehicleLoad, setIsInitialVehicleLoad] = useState(true);
  const [wasVehicleSelected, setWasVehicleSelected] = useState(false);
  const overviewFitCompletedRef = useRef(false);
  const prevSelectedVehiclePlateRef = useRef(null);
  const qiMapListenerTargetRef = useRef(null);
  const googleMapListenerTargetRef = useRef(null);
  const [changedSelectedDevice, setChangedSelectedDevice] = useState(false);

  //Calculate Latest Date
  /*  useEffect(() => {
    try {
      setSelectedRangeHistory({
        startDate: moment().subtract(1, "hours"),
        endDate: moment(),
      });
    } catch (e) {}
  }, [deviceId]); */

  const openDeviceModal = () => {
    setShowDetails(false);
    addNewBox(100);
  };
  const { realTimedata } = useWebSocket(
    String(clientId),
    "all",
    "sub_all",
    deviceId,
    "source_id",
    deviceId,
    selectedVehiclePlate,
  );

  useEffect(() => {
    const selectedClientId = JSON.parse(localStorage.getItem("selected-app-id"));
    const currentUser = JSON.parse(localStorage.getItem("current-user"))?.client_apps?.find(
      (item) => {
        return item.id === selectedClientId;
      },
    );
    setClientId(currentUser?.client?.id);
    try {
      if (currentUser?.client?.config_json) {
        const mapProvider = configJson?.tracking?.web?.map;
        const clientConfig = configJson;

        if (mapProvider?.provider === "mapbox" && mapProvider?.mapboxAccessToken) {
          setClientConfig(clientConfig);
          setMapProvider("mapbox");
          setMapBoxAccessToken(mapProvider.mapboxAccessToken);
          setGoogleMapsApiKey(null);
        } else if (mapProvider?.provider === "google" && mapProvider?.googleMapsApiKey) {
          setClientConfig(clientConfig);
          setMapProvider("google");
          setMapBoxAccessToken(null);
          setGoogleMapsApiKey(mapProvider.googleMapsApiKey);
        } else {
          setClientConfig(clientConfig);
          setMapProvider("qiMap");
          setMapBoxAccessToken(null);
          setGoogleMapsApiKey(null);
        }
      }
    } catch (e) {
      console.log(e);
    }

    //clean up client id on component unmount
    return () => setClientId(null);
  }, []);

  const [q, setQ] = useState("");
  const [page1, setPage1] = useState(1);
  const [perPage1, setPerPage1] = useState(20);
  const pagination = {
    page: page1,
    perPage: perPage1,
    onPageChange: setPage1,
    onPerPageChange: setPerPage1,
  };

  // When page changes, any selected row should be removed
  useEffect(() => {
    if (currentTab === "RawData") {
      setCurrentTab("Map");
    }
    setSelectedRowId(null);
    removeLayerOnClose();
    setDeviceId(null);
    setDockAlign("cross");
  }, [page1]);

  // When page changes from active to all and vice versa, any selected row should be removed
  useEffect(() => {
    if (currentTab === "RawData") {
      setCurrentTab("Map");
    }
    setSelectedRowId(null);
    removeLayerOnClose();
    setDeviceId(null);
    setDockAlign("cross");
  }, [sortedDataDisplay]);

  useEffect(() => {
    if (sortedDataDisplay) {
      setQ(simpleSearch);
    } else {
      let obj = {
        name_or_device_id_or_filter_device_ph_with_country_code_cont: simpleSearch.toUpperCase(),
        filter_device_imei_cont: simpleSearch.toUpperCase(),
        m: "or",
      };
      setQ(encodeURIComponent(JSON.stringify(obj)));
    }
    setPage1(1);
  }, [simpleSearch]);

  useEffect(() => {
    if (sortedDataDisplay) {
      setQ(simpleSearch);
    } else {
      let obj = {
        name_or_device_id_or_filter_device_ph_with_country_code_cont: simpleSearch.toUpperCase(),
        filter_device_imei_cont: simpleSearch.toUpperCase(),
        m: "or",
      };
      setQ(encodeURIComponent(JSON.stringify(obj)));
    }
    setPage1(1);
  }, [simpleSearch]);

  useEffect(() => {
    setSimpleSearch("");
    setPage1(1);
    setPerPage1(20);
    if (sortedDataDisplay) {
      setQ("");
    } else {
      let obj = {
        name_or_plate_number_cont: simpleSearch.toUpperCase(),
        filter_device_imei_cont: simpleSearch.toUpperCase(),
        m: "or",
      };
      setQ(encodeURIComponent(JSON.stringify(obj)));
    }
  }, [sortedDataDisplay]);

  const getQueryParams = () => {
    if (sortedDataDisplay && nonAdminUserId !== "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
        filter: true,
        device_ids: sourceIds,
        q: q,
      };
    } else if (sortedDataDisplay && nonAdminUserId === "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
        filter: true,
        q: q,
      };
    } else if (!sortedDataDisplay && nonAdminUserId !== "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
        device_ids: sourceIds,
      };
    } else if (!sortedDataDisplay && nonAdminUserId === "") {
      return {
        page: pagination?.page - 1,
        per_page: pagination?.perPage,
      };
    }
  };

  /* Get vehicle position and plot in map */
  const { data: trackingData = { data: [] }, refetch } = useGetDevicesTrackingQuery(
    getQueryParams(),
    {
      pollingInterval: sortedDataDisplay && !simpleSearch ? 15000 : 0,
      refetchOnMountOrArgChange: true,
    },
    // fields: "device_data.source_id,device_data.gps,device_data.velocity,device_data.ignition",
  );

  /* Get Variable Data Mappings */
  const { data: mappingData } = useGetVariablesDataQuery({ per_page: 2000, page: variablePage });

  /* Load data to get data for show details */
  useEffect(() => {
    let device;
    if (trackingData && trackingData?.latest_data?.length) {
      let deviceIds = [];
      let deviceSourceId;
      let plateNo;
      let deviceName;
      let trackingPoints = [];

      const tempDeviceData = trackingData?.latest_data.map((datum) => {
        if (
          datum?.device_data?.source_id ||
          datum?.device_reply?.source_id ||
          datum?.login?.source_id ||
          datum?.registration?.source_id ||
          datum?.heartbeat?.source_id
        ) {
          deviceSourceId =
            datum?.device_data?.source_id ||
            datum?.device_reply?.source_id ||
            datum?.login?.source_id ||
            datum?.registration?.source_id ||
            datum?.heartbeat?.source_id;
          deviceIds.push(
            datum?.device_data?.source_id ||
              datum?.device_reply?.source_id ||
              datum?.login?.source_id ||
              datum?.registration?.source_id ||
              datum?.heartbeat?.source_id,
          );
        }
        if (
          datum?.device_data?.plate_number?.v ||
          datum?.device_reply?.plate_number?.v ||
          datum?.login?.plate_number?.v ||
          datum?.registration?.plate_number?.v ||
          datum?.heartbeat?.plate_number?.v
        ) {
          plateNo =
            datum?.device_data?.plate_number?.v ||
            datum?.device_reply?.plate_number?.v ||
            datum?.login?.plate_number?.v ||
            datum?.registration?.plate_number?.v ||
            datum?.heartbeat?.plate_number?.v;
        }

        deviceName =
          datum?.device_data?.other_data?.device_name?.v ||
          datum?.device_reply?.other_data?.device_name?.v ||
          datum?.login?.other_data?.device_name?.v ||
          datum?.registration?.other_data?.device_name?.v ||
          datum?.heartbeat?.other_data?.device_name?.v ||
          "";

        const movement = selectLatestDeviceMovement(datum);

        const position = datum?.device_data?.gps?.v?.position;
        const direction = datum?.device_data?.velocity?.v?.direction;
        let ignition = datum?.device_data?.ignition?.v;

        const { observedAt, rawSpeed, movementStatus } = resolveTrackingStatus(
          movement,
          ignition,
          getVehicleDeviceDataTimestamp(datum),
        );
        const statusPresentation = MOVEMENT_STATUS_PRESENTATION[movementStatus];

        trackingPoints.push({
          ...position,
          id: deviceSourceId,
          device_name_list: deviceSourceId,
          imei: deviceSourceId,
          direction,
          speed: rawSpeed === 0 ? "0 km/h" : rawSpeed && `${(rawSpeed * 3.6).toFixed(1)} km/h`,
          rawSpeed,
          movementTime: movement?.observedAt ?? null,
          source_time: observedAt,
          ignition,
          plate_number: plateNo,
          movementStatus,
          statusColor: statusPresentation.color,
          statusIcon: statusPresentation.icon,
        });

        return {
          device_name_list: deviceSourceId,
          plate_number: plateNo,
          id: deviceSourceId,
          device_name: deviceName,
          lastUpdated: observedAt,
          movementTime: movement?.observedAt ?? null,
          ignition,
          speed: rawSpeed === 0 ? "0 km/h" : rawSpeed && `${(rawSpeed * 3.6).toFixed(1)} km/h`,
          rawSpeed,
          movementStatus,
          statusColor: statusPresentation.color,
          statusIcon: statusPresentation.icon,
        };
      });

      setTrackingPoints(trackingPoints.filter((device) => device.lat !== 0 && device.lng !== 0));

      setDevicesData(tempDeviceData);

      device =
        (trackingData?.latest_data || [])?.find(
          ({ device_data }) => device_data?.source_id === deviceId,
        ) || {};
      setDeviceData(device?.device_data || {});
    }
    if (trackingData && !trackingData?.latest_data?.length) {
      setDeviceData({});
      setDevicesData([]);
    }
  }, [trackingData, deviceId]);

  // Returns the latest time
  const getLatestTime = (t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12) => {
    let validTime1 = 0,
      validTime2 = 0,
      validTime3 = 0,
      validTime4 = 0,
      validTime5 = 0,
      validTime6 = 0,
      validTime7 = 0,
      validTime8 = 0,
      validTime9 = 0,
      validTime10 = 0,
      validTime11 = 0,
      validTime12 = 0;
    if (typeof t1 == "number") {
      validTime1 = t1;
    }
    if (typeof t2 == "number") {
      validTime2 = t2;
    }
    if (typeof t3 == "number") {
      validTime3 = t3;
    }
    if (typeof t4 == "number") {
      validTime4 = t4;
    }
    if (typeof t5 == "number") {
      validTime5 = t5;
    }
    if (typeof t6 == "number") {
      validTime6 = t6;
    }
    if (typeof t7 == "number") {
      validTime7 = t7;
    }
    if (typeof t8 == "number") {
      validTime8 = t8;
    }
    if (typeof t9 == "number") {
      validTime9 = t9;
    }
    if (typeof t10 == "number") {
      validTime10 = t10;
    }
    if (typeof t11 == "number") {
      validTime11 = t11;
    }
    if (typeof t12 == "number") {
      validTime12 = t12;
    }

    return Math.max(
      validTime1,
      validTime2,
      validTime3,
      validTime4,
      validTime5,
      validTime6,
      validTime7,
      validTime8,
      validTime9,
      validTime10,
      validTime11,
      validTime12,
    );
  };

  //Debounce to optimize performance

  const processTrackingData = useCallback(
    debounce((trackingData, realTimedata) => {
      const filteredPosition = {};
      const trackingPoints = [];

      trackingData.latest_data.forEach((data) => {
        const sourceId =
          data?.device_data?.source_id ||
          data?.heartbeat?.source_id ||
          data?.login?.source_id ||
          data?.registration?.source_id;
        const realTimeDataForSource = realTimedata[sourceId];
        const movement = selectLatestDeviceMovement(data, realTimeDataForSource);
        const position =
          realTimeDataForSource?.gps?.position || data?.device_data?.gps?.v?.position;
        const direction =
          realTimeDataForSource?.velocity?.direction || data?.device_data?.velocity?.v?.direction;
        const sourceTime = getLatestTime(
          mapData[sourceId]?.sourceTime,
          realTimeDataForSource?.source_time,
          data?.device_data?.source_time?.v,
          data?.device_data?.source_time,
          data?.heartbeat?.source_time?.v,
          data?.heartbeat?.source_time,
          data?.login?.source_time?.v,
          data?.login?.source_time,
          data?.device_reply?.source_time?.v,
          data?.device_reply?.source_time,
          data?.registration?.source_time?.v,
          data?.registration?.source_time,
        );

        const serverTime =
          realTimeDataForSource?.server_time ||
          data?.device_data?.server_time?.v ||
          data?.device_data?.server_time ||
          data?.heartbeat?.server_time?.v ||
          data?.heartbeat?.server_time ||
          data?.login?.server_time?.v ||
          data?.login?.server_time ||
          data?.device_reply?.server_time?.v ||
          data?.device_reply?.server_time ||
          data?.registration?.server_time?.v ||
          data?.registration?.server_time;
        const plate_number = data?.device_data?.plate_number?.v || data?.heartbeat?.plate_number?.v;

        // Fix ignition status logic - only set it as a boolean value when properly defined
        let ignition = "Unknown";
        if (realTimeDataForSource?.ignition !== undefined) {
          ignition = realTimeDataForSource.ignition;
        } else if (data?.device_data?.ignition?.v !== undefined) {
          ignition = data.device_data.ignition.v;
        }

        const { observedAt: statusTime, rawSpeed, movementStatus } = resolveTrackingStatus(
          movement,
          ignition,
          getVehicleDeviceDataTimestamp(data),
        );
        const speed = rawSpeed === 0 || rawSpeed ? `${(rawSpeed * 3.6).toFixed(1)} km/h` : "Not Available";
        const statusPresentation = MOVEMENT_STATUS_PRESENTATION[movementStatus];

        if (sourceId) {
          filteredPosition[sourceId] = {
            speed,
            rawSpeed,
            direction,
            ignition,
            statusTime,
            sourceTime,
            plate_number,
            serverTime,
          };
          trackingPoints.push({
            ...position,
            imei: sourceId,
            direction,
            speed,
            rawSpeed,
            source_time: statusTime,
            movementTime: movement?.observedAt ?? null,
            ignition,
            plate_number,
            movementStatus,
            statusColor: statusPresentation.color,
            statusIcon: statusPresentation.icon,
          });
        }
      });

      setMapData(filteredPosition);
      //setTrackingPoints(trackingPoints.filter((device) => device.lat !== 0 && device.lng !== 0));
    }, 3000),
    [],
  );

  // Auto refresh the tracking data every 15 seconds
  useEffect(() => {
    const shouldPoll = sortedDataDisplay && !simpleSearch;

    if (shouldPoll) {
      const refreshInterval = setInterval(() => {
        setIsRefreshing(true);
        // This will trigger a re-fetch of the tracking data
        setLastRefreshTime(Date.now());

        // Reset the refreshing state after a more visible delay to show the animation
        setTimeout(() => {
          setIsRefreshing(false);
        }, 2000); // 2000ms for more visibility
      }, 15000);

      return () => clearInterval(refreshInterval);
    }
  }, [sortedDataDisplay, simpleSearch]);

  // Store the previous search to refresh when the filter is cleared.
  const prevSimpleSearchRef = useRef(simpleSearch);

  // Handle immediate refresh when search is cleared
  useEffect(() => {
    const wasSearchPreviouslyActive = prevSimpleSearchRef.current && !simpleSearch;
    const shouldPoll = sortedDataDisplay && !simpleSearch;
    const timeElapsedSinceLastRefresh = Date.now() - lastRefreshTime;

    // Update refs for next comparison
    prevSimpleSearchRef.current = simpleSearch;

    // Refresh if polling resumes after search and the last refresh is stale.
    if (
      shouldPoll &&
      wasSearchPreviouslyActive &&
      timeElapsedSinceLastRefresh > 15000
    ) {
      setIsRefreshing(true);
      setLastRefreshTime(Date.now());

      // Force a refetch of the tracking data
      refetch();

      setTimeout(() => {
        setIsRefreshing(false);
      }, 2000);
    }
  }, [simpleSearch, sortedDataDisplay]);

  //Live Tracking
  useEffect(() => {
    if (realTimedata[deviceId]) {
      const realTimeInfo = realTimedata[deviceId];
      const maxHdopThreshold = 100; // Define HDOP threshold

      // Add GPS validation check
      if (
        !realTimeInfo?.gps ||
        !realTimeInfo?.gps?.position?.is_valid ||
        (realTimeInfo?.gps?.hdop && realTimeInfo?.gps?.hdop > maxHdopThreshold) ||
        realTimeInfo?.packet_type !== "device_data" ||
        !setIsTrackPointsHistoryDataCollected
      ) {
        return; // Skip invalid GPS data
      }

      const newTrackPoints = {
        ...realTimeInfo?.gps?.position,
        direction: realTimeInfo?.velocity?.direction,
        speed: realTimeInfo?.velocity?.speed,
        plate_number: selectedVehiclePlate,
        timestamp: moment(realTimeInfo?.source_time || new Date()).valueOf(),
      };

      setLiveTrackingData((prev) => sortAndRemoveDuplicatesByTimestamp(prev, newTrackPoints));
    }
  }, [realTimedata, deviceId, trackpointsHistoryData, setIsTrackPointsHistoryDataCollected]);

  useEffect(() => {
    if (trackpointsHistoryData.length !== 0 && changedSelectedDevice) {
      setLiveTrackingData(trackpointsHistoryData);
      setChangedSelectedDevice(false);
    }
  }, [trackpointsHistoryData, changedSelectedDevice]);

  useEffect(() => {
    if (deviceId) {
      setChangedSelectedDevice(true);
    }
  }, [deviceId]);

  // Process tracking data when it changes
  useEffect(() => {
    if (!trackingData?.latest_data) return;
    processTrackingData(trackingData, realTimedata);
  }, [trackingData, realTimedata, simpleSearch, processTrackingData]);

  //Debounce to optimize performance End

  // Auto-follow latest point when no user interaction (separate behavior)
  useEffect(() => {
    // Only auto-follow if:
    // 1. QI Map provider
    // 2. User hasn't manually adjusted the map (or we're on initial load)
    // 3. No specific vehicle is selected (general tracking view)
    // 4. Has tracking data to follow
    if (
      mapProvider !== "qiMap" ||
      overviewFitCompletedRef.current ||
      (!initialLoad && userHasAdjustedMap) ||
      deviceId ||
      !mapRef ||
      !trackingPoints?.length
    ) {
      return;
    }

    try {
      // Find the latest point from all tracking data
      let latestPoint = null;
      let latestTime = 0;

      // Check live tracking data first (most recent)
      if (liveTrackingData?.length) {
        const lastLivePoint = liveTrackingData[liveTrackingData.length - 1];
        if (lastLivePoint?.timestamp > latestTime) {
          latestTime = lastLivePoint.timestamp;
          latestPoint = lastLivePoint;
        }
      }

      // Check tracking points if no live data or for comparison
      if (trackingPoints?.length) {
        // For general tracking points, use the last one in the array
        // (assuming they're ordered by recency)
        const lastTrackingPoint = trackingPoints[trackingPoints.length - 1];
        if (lastTrackingPoint && (!latestPoint || !latestTime)) {
          latestPoint = lastTrackingPoint;
        }
      }

      // Update map center to latest point
      if (latestPoint && latestPoint.lat && latestPoint.lng) {
        const olMap = mapRef.getMapReference();
        if (olMap && olMap.getView) {
          const view = olMap.getView();
          if (view && view.setCenter) {
            const transformedLocation = fromLonLat([latestPoint.lng, latestPoint.lat]);

            // Temporarily disable user interaction tracking during programmatic changes
            window.qiMapProgrammaticChange = true;

            if (initialLoad) {
              // On initial load, immediately center without animation
              view.setCenter(transformedLocation);
              view.setZoom(12);
              setCurrentMapZoom(12);
            } else {
              // After initial load, smoothly animate to the new center
              view.animate({
                center: transformedLocation,
                duration: 1000, // 1 second smooth transition
              });
            }

            // Update stored center
            setCurrentMapCenter(transformedLocation);

            // Re-enable user interaction tracking after a short delay
            setTimeout(() => {
              window.qiMapProgrammaticChange = false;
            }, 1100); // Slightly longer than animation duration
          }
        }
      }
    } catch (e) {
      console.warn("Error auto-following latest point:", e);
    }
  }, [
    mapProvider,
    userHasAdjustedMap,
    initialLoad,
    deviceId,
    mapRef,
    trackingPoints,
    liveTrackingData,
    realTimedata, // Include realTimedata to trigger on real-time updates
  ]);

  /* Variable Data Mapping */
  useEffect(() => {
    if (mappingData?.data?.length) {
      mappingData?.data?.map((item, id) => {
        const format = item?.section_value;
        setVariableData((prev) => ({
          ...prev,
          [`${format ? format + "." : ""}${item?.name}`]: { ...item },
        }));
        return null;
      });
      setVariablePage((prev) => prev + 1);
    }
  }, [mappingData]);

  /* Dispatch Variable Data to Global Store */
  useEffect(() => {
    if (variableData) {
      dispatch(setVariableDatas(variableData));
    }
  }, [variableData, dispatch]);

  // Helper function to handle show point on map call for all providers
  const handleShowPointOnMap = (provider) => {
    if (deviceId || selectedVehiclePlate) {
      try {
        showPontOnMap(deviceId, selectedVehiclePlate);
      } catch (e) {
        console.warn(`Error calling showPontOnMap for ${provider}:`, e);
      }
    }
  };

  function handleDeviceMarkerClick(data) {
    const uniqueId = `${data?.id}-${data?.plate_number}`;

    if (selectedRowId === uniqueId) {
      setSelectedRowId(null);
      removeLayerOnClose();
      setShowDetails(false);
      setDeviceId(null);
      setselectedVehiclePlate(null);
      setselectedDeviceName(null);
      setDockAlign("cross");
      setCurrentTab("Map");
      setVehicleData(null);
      return;
    }

    setSelectedRowId(uniqueId);
    setShowDetails(true);
    removeLayerOnClose();
    setDeviceId(data?.device_name_list || data?.device_id || data?.imei);
    setselectedVehiclePlate(data?.plate_number);
    setselectedDeviceName(data?.device_name_list || data?.imei);
    setVehicleData(data);

    dockAlign === "cross" && setDockAlign(globalDockAlign);
    globalDockAlign === "pop-out" && addNewBox(100);
  }

  // ── Map Clustering ──
  // Clustering is active when no device is selected (overview mode)
  const clusterEnabled = !deviceId && !selectedVehiclePlate;
  const validPointsForCluster = useMemo(
    () => getRenderableTrackingPoints(trackingPoints, "imei"),
    [trackingPoints],
  );
  const { clusterIndex, zoomVersion, onClusterClick } = useMapClustering({
    mapRef,
    mapProvider,
    trackingPoints: validPointsForCluster,
    enabled: clusterEnabled,
  });

  //Map tracking
  useEffect(() => {
    const layerName = `test_${count}`;
    const prevLayer = `test_${count - 1}`;
    const updatedTrackingPoints = getRenderableTrackingPoints(trackingPoints, "imei").map(
      (point) => {
        const rtData = realTimedata[point.imei];
        if (!rtData) return point;
        const previous = point.rawSpeed == null ? null : {
          device_data: { velocity: { t: point.movementTime, v: { speed: point.rawSpeed } } },
        };
        const movement = selectLatestDeviceMovement(previous, rtData);
        const ignition = rtData.packet_type === "device_data" && rtData.ignition !== undefined
          ? rtData.ignition : point.ignition;
        const { observedAt, rawSpeed, movementStatus } = resolveTrackingStatus(
          movement,
          ignition,
          point.source_time,
        );
        const statusPresentation = MOVEMENT_STATUS_PRESENTATION[movementStatus];
        return {
          ...point,
          source_time: observedAt,
          movementTime: movement?.observedAt ?? null,
          rawSpeed,
          ignition,
          movementStatus,
          statusColor: statusPresentation.color,
          statusIcon: statusPresentation.icon,
        };
      },
    );

    if (!mapProvider || mapProvider === "qiMap") {
      if (mapRef && updatedTrackingPoints.length && !deviceId) {
        // Add event listeners to track user interactions (only once)
        if (mapRef && mapRef.getMapReference) {
          try {
            const olMap = mapRef.getMapReference();
            if (olMap?.on && shouldAttachMapListeners(qiMapListenerTargetRef.current, olMap)) {
              attachQiMapManualInteractionListeners(olMap, () => {
                setUserHasAdjustedMap(true);
              });

              // Listen for zoom changes
              olMap.on("change:resolution", () => {
                try {
                  // Only consider it user interaction if not a programmatic change
                  if (!window.qiMapProgrammaticChange) {
                    setUserHasAdjustedMap(true);
                  }
                  const view = olMap.getView();
                  if (view && view.getZoom) {
                    setCurrentMapZoom(view.getZoom());
                  }
                } catch (e) {
                  console.warn("Error tracking QI Map zoom change:", e);
                }
              });

              // Listen for pan/move events
              olMap.on("moveend", () => {
                try {
                  // Only consider it user interaction if not a programmatic change
                  if (!window.qiMapProgrammaticChange) {
                    setUserHasAdjustedMap(true);
                  }
                  const view = olMap.getView();
                  if (view && view.getCenter) {
                    setCurrentMapCenter(view.getCenter());
                  }
                } catch (e) {
                  console.warn("Error tracking QI Map move:", e);
                }
              });

              qiMapListenerTargetRef.current = olMap;
            }
          } catch (e) {
            console.warn("Error adding QI Map event listeners:", e);
          }
        }

        count && mapRef.removeLayer(prevLayer);
        mapRef.addLayer({ name: layerName });

        // Store current zoom/center before redrawing if user has adjusted map
        let preserveZoom = null;
        let preserveCenter = null;
        if (userHasAdjustedMap && !initialLoad && !wasVehicleSelected) {
          try {
            const olMap = mapRef.getMapReference();
            if (olMap && olMap.getView) {
              const view = olMap.getView();
              if (view) {
                preserveZoom = view.getZoom ? view.getZoom() : currentMapZoom;
                preserveCenter = view.getCenter ? view.getCenter() : currentMapCenter;
              }
            }
          } catch (e) {
            preserveZoom = currentMapZoom;
            preserveCenter = currentMapCenter;
          }
        }

        // Compute clusters before drawing; the initial fit keeps every point in the layer.
        const shouldFitOverview =
          (initialLoad || wasVehicleSelected) && (!userHasAdjustedMap || initialLoad);
        let currentClusters = [];
        if (clusterEnabled && clusterIndex) {
          const viewport = getMapViewport(mapRef, mapProvider);
          currentClusters = viewport
            ? getVisibleClusters(clusterIndex, viewport.bbox, viewport.zoom)
            : [];
        }
        const pointsToDraw = selectOverviewPointsToDraw(
          updatedTrackingPoints,
          currentClusters,
          shouldFitOverview,
        );

        mapRef.drawTrack({
          layerName: layerName,
          fitWithinView: false,
          trackType: "point",
          data: [{ coordinates: pointsToDraw }],
          style: {
            point: {
              style: (feature) => {
                const isSelected = feature.plate_number === selectedVehiclePlate;
                return new Style({
                  zIndex: isSelected ? 10 : 1,
                  image: new Icon({
                    color: "#fff",
                    crossOrigin: "anonymous",
                    src: direction,
                    imgSize: [34, 40],
                    rotation: feature.direction,
                  }),
                });
              },
            },
          },
        });

        // Render labels and cluster markers
        if (clusterEnabled && clusterIndex && currentClusters.length > 0) {
          const unclusteredPoints = currentClusters
            .filter((f) => !isClusterFeature(f))
            .map((f) => f.properties);
          renderQiMapDeviceLabels(mapRef, unclusteredPoints, handleDeviceMarkerClick);
          renderQiMapClusterMarkers(
            mapRef,
            currentClusters,
            clusterIndex,
            onClusterClick,
            handleDeviceMarkerClick,
          );
        } else {
          renderQiMapDeviceLabels(mapRef, updatedTrackingPoints, handleDeviceMarkerClick);
          clearQiMapClusterMarkers(mapRef);
        }

        // Fit all markers on initial load or when returning from device selection
        if (shouldFitOverview) {
          try {
            // Mark as programmatic change
            window.qiMapProgrammaticChange = true;

            // Fit to all markers
            mapRef.performFit(layerName);

            // Store the zoom and center after fitting
            setTimeout(() => {
              const olMap = mapRef.getMapReference();
              if (olMap && olMap.getView) {
                const view = olMap.getView();
                if (view) {
                  const fittedZoom = view.getZoom ? view.getZoom() : null;
                  const overviewZoom = getOverviewFitZoom(
                    fittedZoom,
                    view.getMinZoom ? view.getMinZoom() : 0,
                  );
                  if (view.setZoom && overviewZoom !== fittedZoom) {
                    view.setZoom(overviewZoom);
                  }
                  setCurrentMapZoom(overviewZoom);
                  setCurrentMapCenter(view.getCenter ? view.getCenter() : null);
                }
              }
              window.qiMapProgrammaticChange = false;
            }, 100);

            setInitialLoad(false); // Disable initial load after first fit
            overviewFitCompletedRef.current = true;
            setWasVehicleSelected(false); // Reset after fitting
          } catch (e) {
            console.log(e);
            setInitialLoad(false);
            setWasVehicleSelected(false); // Reset even on error
          }
        } else if (preserveZoom !== null && preserveCenter !== null) {
          // Restore user's zoom and center after redrawing markers
          try {
            const olMap = mapRef.getMapReference();
            if (olMap && olMap.getView) {
              const view = olMap.getView();
              if (view && view.setZoom && view.setCenter) {
                // Mark as programmatic change
                window.qiMapProgrammaticChange = true;

                view.setZoom(preserveZoom);
                view.setCenter(preserveCenter);

                // Re-enable user interaction tracking
                setTimeout(() => {
                  window.qiMapProgrammaticChange = false;
                }, 50);
              }
            }
          } catch (e) {
            console.warn("Error restoring QI Map zoom/center:", e);
          }
        }
      } else {
        mapRef?.removeLayer(`test_${count - 1}`);
        clearQiMapDeviceLabels(mapRef);
      }
      handleShowPointOnMap("qiMap");
    } else if (mapRef && updatedTrackingPoints.length && mapProvider === "mapbox" && !deviceId) {
      const onStyleLoaded = () => {
        // Register a custom icon
        mapRef.loadImage(direction, (error, image) => {
          if (error) throw error;

          // Check if the image is already added
          if (!mapRef.hasImage("custom-icon")) {
            mapRef.addImage("custom-icon", image);
          }

          // Remove the previous layer if it exists
          if (mapRef.getLayer(layerName)) {
            mapRef.removeLayer(layerName);
            mapRef.removeSource(layerName);
          }

          // Use Mapbox native clustering
          renderMapboxClusters(
            mapRef,
            updatedTrackingPoints,
            handleDeviceMarkerClick,
            selectedVehiclePlate,
          );

          // Fit the map to the tracking points on initial load
          if (initialLoad) {
            const coordinates = updatedTrackingPoints.map((p) => [p.lng, p.lat]);
            const bounds = coordinates.reduce(
              (bounds, coord) => bounds.extend(coord),
              new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]),
            );

            mapRef.fitBounds(bounds, { padding: 50, duration: 1000 });
            setInitialLoad(false);
          }
        });
      };

      // Check if the style is already loaded
      if (mapRef && typeof mapRef.isStyleLoaded === "function" && mapRef.isStyleLoaded()) {
        onStyleLoaded();
      } else if (mapRef && typeof mapRef.on === "function") {
        // Wait for the style to load
        mapRef.on("style.load", onStyleLoaded);
      }
    } else if (
      mapProvider === "google" &&
      mapRef &&
      updatedTrackingPoints.length &&
      typeof mapRef.fitBounds === "function" &&
      !deviceId
    ) {
      // For Google Maps - use clustering via supercluster
      // Clear previous markers and overlays safely
      if (window.googleMarkers && Array.isArray(window.googleMarkers)) {
        window.googleMarkers.forEach((marker) => {
          try {
            if (marker && typeof marker.setMap === "function") {
              marker.setMap(null);
            }
          } catch (e) {}
        });
      }
      if (window.googleOverlays && Array.isArray(window.googleOverlays)) {
        window.googleOverlays.forEach((overlay) => {
          try {
            if (overlay && typeof overlay.setMap === "function") {
              overlay.setMap(null);
            }
          } catch (e) {}
        });
      }
      window.googleMarkers = [];
      window.googleOverlays = [];

      // Render clustered markers using supercluster data
      if (clusterEnabled && clusterIndex) {
        const viewport = getMapViewport(mapRef, "google");
        const currentClusters = viewport
          ? getVisibleClusters(clusterIndex, viewport.bbox, viewport.zoom)
          : [];
        if (currentClusters.length > 0) {
          renderGoogleMapClusters(
            mapRef,
            currentClusters,
            clusterIndex,
            handleDeviceMarkerClick,
            selectedVehiclePlate,
          );
        } else {
          updatedTrackingPoints.forEach((point) => {
            const position = { lat: point.lat, lng: point.lng };
            try {
              const marker = new google.maps.Marker({
                position,
                map: mapRef,
                icon: googleDirectionIcon(point.direction),
                zIndex: point.plate_number === selectedVehiclePlate ? 10 : 1,
              });
              marker.addListener("click", () => handleDeviceMarkerClick(point));
              window.googleMarkers.push(marker);
            } catch (e) {}
          });
        }
      } else {
        updatedTrackingPoints.forEach((point) => {
          const position = { lat: point.lat, lng: point.lng };
          try {
            const marker = new google.maps.Marker({
              position,
              map: mapRef,
              icon: googleDirectionIcon(point.direction),
              zIndex: point.plate_number === selectedVehiclePlate ? 10 : 1,
            });
            marker.addListener("click", () => handleDeviceMarkerClick(point));
            window.googleMarkers.push(marker);
          } catch (e) {}
        });
      }

      // Fit bounds on initial load
      if ((initialLoad || wasVehicleSelected) && mapRef && typeof mapRef.fitBounds === "function") {
        try {
          const bounds = new google.maps.LatLngBounds();
          updatedTrackingPoints.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
          mapRef.fitBounds(bounds);
          setInitialLoad(false);
          setWasVehicleSelected(false);
        } catch (e) {
          setInitialLoad(false);
          setWasVehicleSelected(false);
        }
      }
    } else {
      handleShowPointOnMap(mapProvider);
    }
    //Increase layer count
    setCount((c) => c + 1);
  }, [
    mapRef,
    trackingPoints,
    deviceId,
    initialLoad,
    mapProvider,
    isRefreshing,
    vehicleData,
    selectedVehiclePlate,
    liveTrackingData,
    currentTab,
    wasVehicleSelected,
    mapResetCount,
    clusterIndex,
    zoomVersion,
    clusterEnabled,
  ]);
  // Show single point on map (on selection)
  function showPontOnMap(data_id, plate_number) {
    if (!mapRef || !mapProvider) return;

    let imei_info = trackingPoints.find((device_data) => device_data.imei === data_id);
    let layerName = `imei-details_${selectedRow}`;

    if (mapProvider === "qiMap") {
      // Add event listeners to track user interactions (only once)
      if (mapRef && mapRef.getMapReference) {
        try {
          const olMap = mapRef.getMapReference();
          if (olMap?.on && shouldAttachMapListeners(qiMapListenerTargetRef.current, olMap)) {
            attachQiMapManualInteractionListeners(olMap, () => {
              setUserHasAdjustedMap(true);
            });

            // Listen for zoom changes
            olMap.on("change:resolution", () => {
              try {
                // Only consider it user interaction if not a programmatic change
                if (!window.qiMapProgrammaticChange) {
                  setUserHasAdjustedMap(true);
                }
                const view = olMap.getView();
                if (view && view.getZoom) {
                  setCurrentMapZoom(view.getZoom());
                }
              } catch (e) {
                console.warn("Error tracking QI Map zoom change:", e);
              }
            });

            // Listen for pan/move events
            olMap.on("moveend", () => {
              try {
                // Only consider it user interaction if not a programmatic change
                if (!window.qiMapProgrammaticChange) {
                  setUserHasAdjustedMap(true);
                }
                const view = olMap.getView();
                if (view && view.getCenter) {
                  setCurrentMapCenter(view.getCenter());
                }
              } catch (e) {
                console.warn("Error tracking QI Map move:", e);
              }
            });

            qiMapListenerTargetRef.current = olMap;
          }
        } catch (e) {
          console.warn("Error adding QI Map event listeners:", e);
        }
      }

      // Store current zoom and center before clearing
      let preserveZoom = null;
      let preserveCenter = null;
      if (userHasAdjustedMap && mapRef && mapRef.getMapReference) {
        try {
          const olMap = mapRef.getMapReference();
          if (olMap && olMap.getView) {
            const view = olMap.getView();
            if (view) {
              preserveZoom = view.getZoom ? view.getZoom() : currentMapZoom;
              preserveCenter = view.getCenter ? view.getCenter() : currentMapCenter;
            }
          }
        } catch (e) {
          console.warn("Error getting QI Map current state:", e);
          preserveZoom = currentMapZoom;
          preserveCenter = currentMapCenter;
        }
      }

      // Remove previous imei-details layer
      selectedRow &&
        mapRef.removeLayerSource &&
        mapRef.removeLayerSource(`imei-details_${selectedRow - 1}`);

      // Remove all tracking points layers (test_ layers) to hide other vehicles
      for (let i = 0; i <= count; i++) {
        try {
          mapRef.removeLayer && mapRef.removeLayer(`test_${i}`);
        } catch (e) {
          // Layer might not exist, continue
        }
      }
      // Clear all device labels from the list view before rendering the selected device label
      clearQiMapDeviceLabels(mapRef);

      if (mapRef && mapRef.addLayer && mapRef.drawTrack) {
        mapRef.addLayer({ name: layerName });
        //Initial Point
        !liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit, we'll handle it manually
            trackType: "point",
            data: [{ coordinates: [imei_info] }],
            style: {
              point: {
                style: (feature) => {
                  const isSelected = feature.plate_number === selectedVehiclePlate;

                  return new Style({
                    zIndex: isSelected ? 10 : 1, // Ensure selected vehicle is on top
                    image: new Icon({
                      color: "#fff",
                      crossOrigin: "anonymous",
                      src: direction,
                      imgSize: [34, 40],
                      anchor: [0.5, 0.9],
                      rotation: getRotation(feature.direction),
                    }),
                  });
                },
              },
            },

            /* tooltip: {
              showOn: "hover",
              content: (feature) => {
                let data = feature.get("data");
                return `<div><strong>${
                  plate_number || data?.plate_number || data?.imei || ""
                }</strong></div>
              <div>${
                data?.address?.name || data?.address?.city || data?.address?.country || ""
              }</div>
              <div>${data?.speed || ""}</div>`;
              },
            }, */
          });

        // Live First Point
        liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit, we'll handle it manually
            trackType: "point",
            data: [{ coordinates: [liveTrackingData[0]] }],
            style: {
              point: {
                style: (feature) => {},
              },
            },
          });

        //Live Last Point
        liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit, we'll handle it manually
            trackType: "point",
            data: [{ coordinates: [liveTrackingData[liveTrackingData.length - 1]] }],
            style: {
              point: {
                style: (feature) => {
                  return new Style({
                    zIndex: 1,
                    image: new Icon({
                      color: "#fff",
                      crossOrigin: "anonymous",
                      src: direction,
                      imgSize: [34, 40],
                      rotation: getRotation(feature.direction),
                    }),
                  });
                },
              },
            },
          });
        //Track Line - Draw automatically when live data flows in
        liveTrackingData?.length &&
          mapRef.drawTrack({
            layerName: layerName,
            fitWithinView: false, // Disable auto-fit for updates
            trackType: "line",
            data: [{ coordinates: liveTrackingData }], // Start from initial trackpoint and include live data
            style: {
              line: {
                style: (feature) => {
                  return new Style({
                    zIndex: 0,
                    stroke: new Stroke({
                      color: "#0767d0",
                      width: 5,
                      lineDash: [5, 5],
                    }),
                  });
                },
              },
            },
          });

        // Draw directional arrows along the track line
        if (liveTrackingData?.length) {
          const arrowPoints = generateDirectionalArrowPoints(liveTrackingData, 500);
          if (arrowPoints.length > 0) {
            mapRef.drawTrack({
              layerName: layerName,
              fitWithinView: false,
              trackType: "point",
              data: [{ coordinates: arrowPoints }],
              style: {
                point: {
                  style: (feature) => {
                    const dir = feature.direction || feature.get?.("data")?.direction || 0;
                    return new Style({
                      zIndex: 2,
                      image: new Icon({
                        src: directionArrow,
                        scale: 0.6,
                        rotation: getRotation(dir + 90),
                        anchor: [0.5, 0.5],
                      }),
                    });
                  },
                },
              },
            });
          }
        }

        // Render device label overlay on the selected device marker (movement status + device ID)
        const labelPoint = liveTrackingData?.length
          ? { ...imei_info, ...liveTrackingData[liveTrackingData.length - 1] }
          : imei_info;
        if (labelPoint && labelPoint.imei) {
          const deviceRealTime = realTimedata[deviceId];
          const labelIgnition =
            deviceRealTime?.packet_type === "device_data" && deviceRealTime.ignition !== undefined
              ? deviceRealTime.ignition
              : (labelPoint.ignition ?? deviceData?.ignition?.v);
          const hasRouteSpeed = typeof labelPoint.speed === "number";
          const labelSpeed = hasRouteSpeed ? labelPoint.speed : labelPoint.rawSpeed;
          const labelTime = hasRouteSpeed ? labelPoint.timestamp : labelPoint.movementTime;
          const labelMovement = selectLatestDeviceMovement({
            device_data: { velocity: { t: labelTime, v: { speed: labelSpeed } } },
          }, deviceRealTime);
          const { movementStatus: labelMovementStatus } = resolveTrackingStatus(
            labelMovement,
            labelIgnition,
            labelPoint.source_time,
          );
          const labelStatusPresentation = MOVEMENT_STATUS_PRESENTATION[labelMovementStatus];
          renderQiMapDeviceLabels(
            mapRef,
            [
              {
                ...labelPoint,
                movementStatus: labelMovementStatus,
                statusColor: labelStatusPresentation.color,
                statusIcon: labelStatusPresentation.icon,
              },
            ],
            handleDeviceMarkerClick,
          );
        }

        // Center on last location instead of fitting on initial vehicle load or when user hasn't manually adjusted the map
        if (isInitialVehicleLoad || !userHasAdjustedMap) {
          try {
            // Determine the last location to center on
            let lastLocation = null;
            if (liveTrackingData?.length) {
              // Use the last point from live tracking data
              const lastPoint = liveTrackingData[liveTrackingData.length - 1];
              lastLocation = [lastPoint.lng, lastPoint.lat];
            } else if (imei_info) {
              // Use the initial point
              lastLocation = [imei_info.lng, imei_info.lat];
            }

            if (lastLocation && mapRef && mapRef.getMapReference) {
              const olMap = mapRef.getMapReference();
              if (olMap && olMap.getView) {
                const view = olMap.getView();
                if (view && view.setCenter && view.setZoom) {
                  // Transform coordinates from lon/lat to map projection and center
                  const transformedLocation = fromLonLat(lastLocation);

                  // Mark as programmatic change
                  window.qiMapProgrammaticChange = true;

                  view.setCenter(transformedLocation);
                  view.setZoom(19); // Set desired zoom level for last location

                  // Store the zoom and center
                  setCurrentMapZoom(19);
                  setCurrentMapCenter(transformedLocation);

                  // Re-enable user interaction tracking
                  setTimeout(() => {
                    window.qiMapProgrammaticChange = false;
                  }, 100);
                }
              }
            }

            setIsInitialVehicleLoad(false); // Mark initial load as complete
          } catch (e) {
            console.warn("Error centering QI Map on last location:", e);
            setIsInitialVehicleLoad(false); // Mark as complete even on error
          }
        } else if (
          !isInitialVehicleLoad &&
          userHasAdjustedMap &&
          preserveZoom !== null &&
          preserveCenter !== null
        ) {
          // Restore user's preferred zoom and center (only after initial load)
          try {
            const olMap = mapRef.getMapReference();
            if (olMap && olMap.getView) {
              const view = olMap.getView();
              if (view && view.setZoom && view.setCenter) {
                // Mark as programmatic change
                window.qiMapProgrammaticChange = true;

                view.setZoom(preserveZoom);
                view.setCenter(preserveCenter); // Already in map projection

                // Re-enable user interaction tracking
                setTimeout(() => {
                  window.qiMapProgrammaticChange = false;
                }, 100);
              }
            }
          } catch (e) {
            console.warn("Error restoring QI Map zoom/center:", e);
          }
        }
      }
    } else if (mapProvider === "mapbox" && mapboxAccessToken) {
      // Clear previous layers
      try {
        if (mapRef.getLayer(layerName)) {
          mapRef.removeLayer(layerName);
        }
        if (mapRef.getSource(layerName)) {
          mapRef.removeSource(layerName);
        }
        // Clear previous tracking layers
        for (let i = 0; i <= count; i++) {
          try {
            if (mapRef.getLayer(`test_${i}`)) {
              mapRef.removeLayer(`test_${i}`);
              mapRef.removeSource(`test_${i}`);
            }
          } catch (e) {
            // Layer might not exist, continue
          }
        }
      } catch (e) {
        console.warn("Error clearing mapbox layers:", e);
      }

      const onStyleLoaded = () => {
        // Load custom icons if not already loaded
        if (!mapRef.hasImage("home-icon")) {
          mapRef.loadImage(homeLocation, (error, image) => {
            if (error) console.warn("Error loading home icon:", error);
            else mapRef.addImage("home-icon", image);
          });
        }
        if (!mapRef.hasImage("direction-icon")) {
          mapRef.loadImage(direction, (error, image) => {
            if (error) console.warn("Error loading direction icon:", error);
            else mapRef.addImage("direction-icon", image);
          });
        }

        // Prepare features array
        const features = [];

        // Add initial point if no live tracking data
        if (!liveTrackingData?.length && imei_info) {
          features.push({
            type: "Feature",
            properties: {
              type: "start",
              plate_number: plate_number,
            },
            geometry: {
              type: "Point",
              coordinates: [imei_info.lng, imei_info.lat],
            },
          });
        }

        // Add live tracking points
        if (liveTrackingData?.length) {
          // Start point
          features.push({
            type: "Feature",
            properties: {
              type: "start",
              plate_number: plate_number,
            },
            geometry: {
              type: "Point",
              coordinates: [liveTrackingData[0].lng, liveTrackingData[0].lat],
            },
          });

          // End point
          const lastPoint = liveTrackingData[liveTrackingData.length - 1];
          features.push({
            type: "Feature",
            properties: {
              type: "end",
              plate_number: plate_number,
              direction: lastPoint.direction,
            },
            geometry: {
              type: "Point",
              coordinates: [lastPoint.lng, lastPoint.lat],
            },
          });

          // Track line
          features.push({
            type: "Feature",
            properties: {
              type: "line",
              plate_number: plate_number,
            },
            geometry: {
              type: "LineString",
              coordinates: liveTrackingData.map((point) => [point.lng, point.lat]),
            },
          });
        }

        // Add source
        mapRef.addSource(layerName, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: features,
          },
        });

        // Add line layer
        mapRef.addLayer({
          id: `${layerName}-line`,
          type: "line",
          source: layerName,
          filter: ["==", ["get", "type"], "line"],
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#0767d0",
            "line-width": 5,
            "line-dasharray": [2, 2],
          },
        });

        // Add points layer
        mapRef.addLayer({
          id: layerName,
          type: "symbol",
          source: layerName,
          filter: ["in", ["get", "type"], ["literal", ["start", "end"]]],
          layout: {
            "icon-image": ["case", ["==", ["get", "type"], "start"], "home-icon", "direction-icon"],
            "icon-size": 0.8,
            "icon-rotate": ["case", ["==", ["get", "type"], "end"], ["get", "direction"], 0],
            "icon-rotation-alignment": "map",
            "icon-allow-overlap": true,
          },
        });

        // Fit bounds
        if (features.length > 0) {
          const coordinates = features
            .filter((f) => f.geometry.type === "Point")
            .map((f) => f.geometry.coordinates);

          if (coordinates.length > 0) {
            const bounds = coordinates.reduce(
              (bounds, coord) => bounds.extend(coord),
              new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]),
            );
            mapRef.fitBounds(bounds, { padding: 50, duration: 1000 });
          }
        }
      };

      // Check if style is loaded
      if (mapRef.isStyleLoaded()) {
        onStyleLoaded();
      } else {
        mapRef.on("style.load", onStyleLoaded);
      }
    } else if (mapProvider === "google" && googleMapsApiKey) {
      // Add event listeners to track user interactions (only once)
      if (shouldAttachMapListeners(googleMapListenerTargetRef.current, mapRef)) {
        // Listen for zoom changes
        google.maps.event.addListener(mapRef, "zoom_changed", () => {
          setUserHasAdjustedMap(true);
          setCurrentMapZoom(mapRef.getZoom());
        });

        // Listen for drag/pan events
        google.maps.event.addListener(mapRef, "dragend", () => {
          setUserHasAdjustedMap(true);
          setCurrentMapCenter(mapRef.getCenter());
        });

        googleMapListenerTargetRef.current = mapRef;
      }

      // Store current zoom and center before clearing
      const preserveZoom = userHasAdjustedMap ? currentMapZoom || mapRef?.getZoom() : null;
      const preserveCenter = userHasAdjustedMap ? currentMapCenter || mapRef?.getCenter() : null;

      // Clear previous markers and overlays
      if (window.googleSelectedMarkers && Array.isArray(window.googleSelectedMarkers)) {
        window.googleSelectedMarkers.forEach((marker) => {
          try {
            if (marker && typeof marker.setMap === "function") {
              marker.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing selected marker:", e);
          }
        });
      }
      if (window.googleSelectedOverlays && Array.isArray(window.googleSelectedOverlays)) {
        window.googleSelectedOverlays.forEach((overlay) => {
          try {
            if (overlay && typeof overlay.setMap === "function") {
              overlay.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing selected overlay:", e);
          }
        });
      }

      // Clear main tracking markers
      if (window.googleMarkers && Array.isArray(window.googleMarkers)) {
        window.googleMarkers.forEach((marker) => {
          try {
            if (marker && typeof marker.setMap === "function") {
              marker.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing marker:", e);
          }
        });
        window.googleMarkers = [];
      }
      if (window.googleOverlays && Array.isArray(window.googleOverlays)) {
        window.googleOverlays.forEach((overlay) => {
          try {
            if (overlay && typeof overlay.setMap === "function") {
              overlay.setMap(null);
            }
          } catch (e) {
            console.warn("Error clearing overlay:", e);
          }
        });
        window.googleOverlays = [];
      }

      // Initialize arrays
      window.googleSelectedMarkers = [];
      window.googleSelectedOverlays = [];
      const bounds = new google.maps.LatLngBounds();

      // Add initial point if no live tracking data
      if (!liveTrackingData?.length && imei_info) {
        const position = { lat: imei_info.lat, lng: imei_info.lng };

        const marker = new google.maps.Marker({
          position,
          map: mapRef,
          icon: googleDirectionIcon(imei_info.direction, 32),
          zIndex: 10,
        });

        bounds.extend(position);
        window.googleSelectedMarkers.push(marker);
      }

      // Add live tracking points and line
      if (liveTrackingData?.length) {
        // Start point
        // const startPosition = { lat: liveTrackingData[0].lat, lng: liveTrackingData[0].lng };
        // const startMarker = new google.maps.Marker({
        //   position: startPosition,
        //   map: mapRef,
        //   icon: {
        //     url: homeLocation,
        //     scaledSize: new google.maps.Size(32, 32),
        //   },
        //   zIndex: 10,
        // });
        // window.googleSelectedMarkers.push(startMarker);
        // bounds.extend(startPosition);

        // End point
        const lastPoint = liveTrackingData[liveTrackingData.length - 1];
        const endPosition = { lat: lastPoint.lat, lng: lastPoint.lng };
        const endMarker = new google.maps.Marker({
          position: endPosition,
          map: mapRef,
          icon: googleDirectionIcon(lastPoint.direction, 32),
          zIndex: 10,
        });
        window.googleSelectedMarkers.push(endMarker);
        bounds.extend(endPosition);

        // Track line
        const path = liveTrackingData.map((point) => ({ lat: point.lat, lng: point.lng }));
        const polyline = new google.maps.Polyline({
          path: path,
          geodesic: true,
          strokeColor: "#0767d0",
          strokeOpacity: 1.0,
          strokeWeight: 5,
          strokeDashArray: "10,5",
          icons: [
            {
              icon: {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                scale: 2.5,
                strokeColor: "#ffffff",
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillColor: "#ffffff",
                fillOpacity: 0.6,
              },
              offset: "0",
              repeat: "100px",
            },
          ],
        });
        polyline.setMap(mapRef);
        window.googleSelectedOverlays.push(polyline);
      }

      // Auto-fit bounds on initial vehicle load or when user hasn't manually adjusted the map
      if (
        window.googleSelectedMarkers.length > 0 &&
        (isInitialVehicleLoad || !userHasAdjustedMap)
      ) {
        try {
          mapRef.fitBounds(bounds);
          // Store the initial zoom and center after fitBounds
          setTimeout(() => {
            setCurrentMapZoom(mapRef.getZoom());
            setCurrentMapCenter(mapRef.getCenter());
            setIsInitialVehicleLoad(false); // Mark initial load as complete
          }, 100);
        } catch (e) {
          console.warn("Error fitting bounds:", e);
          setIsInitialVehicleLoad(false); // Mark as complete even on error
        }
      } else if (
        !isInitialVehicleLoad &&
        userHasAdjustedMap &&
        preserveZoom !== null &&
        preserveCenter !== null
      ) {
        // Restore user's preferred zoom and center (only after initial load)
        try {
          mapRef.setZoom(preserveZoom);
          mapRef.setCenter(preserveCenter);
        } catch (e) {
          console.warn("Error restoring zoom/center:", e);
        }
      }
    }

    setSelectedRow((i) => i + 1);
  }

  const removeLayerOnClose = () => {
    try {
      // Clean up standstill/cluster markers (shared across all providers)
      if (window.standstillMarkers) {
        window.standstillMarkers.forEach((m) => {
          try {
            m.remove();
          } catch (e) {
            /* ignore */
          }
        });
        window.standstillMarkers = [];
      }

      if (mapProvider === "mapbox") {
        // Helper function to remove a Mapbox layer and its source
        const removeLayerAndSource = (id) => {
          if (trackMapRef && trackMapRef.getLayer && trackMapRef.getLayer(id)) {
            trackMapRef.removeLayer(id);
          }
          if (trackMapRef && trackMapRef.getSource && trackMapRef.getSource(id)) {
            trackMapRef.removeSource(id);
          }
        };

        // Remove layers and sources specific to Mapbox
        if (mapRef) {
          removeLayerAndSource(`imei-details_${selectedRow - 1}`);
        }
        if (trackMapRef) {
          removeLayerAndSource(`track_${deviceId}`);
        }
      } else if (mapProvider === "google") {
        // Clear all overlays (markers, polylines) specific to Google Maps
        const removeGoogleOverlays = (prefix) => {
          for (let i = 0; i < count; i++) {
            const overlayGroup = window[`${prefix}_${i}_google`];
            if (overlayGroup && Array.isArray(overlayGroup)) {
              overlayGroup.forEach((overlay) => {
                try {
                  if (overlay && typeof overlay.setMap === "function") {
                    overlay.setMap(null);
                  }
                } catch (e) {
                  console.warn("Error removing overlay:", e);
                }
              });
              window[`${prefix}_${i}_google`] = null; // Clear reference
            }
          }
        };

        // Clear current markers and overlays safely
        if (window.googleMarkers && Array.isArray(window.googleMarkers)) {
          window.googleMarkers.forEach((marker) => {
            try {
              if (marker && typeof marker.setMap === "function") {
                marker.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing marker:", e);
            }
          });
          window.googleMarkers = [];
        }
        if (window.googleOverlays && Array.isArray(window.googleOverlays)) {
          window.googleOverlays.forEach((overlay) => {
            try {
              if (overlay && typeof overlay.setMap === "function") {
                overlay.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing overlay:", e);
            }
          });
          window.googleOverlays = [];
        }

        // Clear selected markers and overlays
        if (window.googleSelectedMarkers && Array.isArray(window.googleSelectedMarkers)) {
          window.googleSelectedMarkers.forEach((marker) => {
            try {
              if (marker && typeof marker.setMap === "function") {
                marker.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing selected marker:", e);
            }
          });
          window.googleSelectedMarkers = [];
        }
        if (window.googleSelectedOverlays && Array.isArray(window.googleSelectedOverlays)) {
          window.googleSelectedOverlays.forEach((overlay) => {
            try {
              if (overlay && typeof overlay.setMap === "function") {
                overlay.setMap(null);
              }
            } catch (e) {
              console.warn("Error removing selected overlay:", e);
            }
          });
          window.googleSelectedOverlays = [];
        }

        // Remove Google-specific overlays for devices (imei-details)
        if (mapRef) {
          // Clear device-specific overlays for all selectedRow iterations
          for (let i = 0; i <= selectedRow; i++) {
            const markerGroup = window[`imei-details_${i}_google_markers`];
            const overlayGroup = window[`imei-details_${i}_google_overlays`];

            if (markerGroup && Array.isArray(markerGroup)) {
              markerGroup.forEach((marker) => {
                try {
                  if (marker && typeof marker.setMap === "function") {
                    marker.setMap(null);
                  }
                } catch (e) {
                  console.warn("Error clearing device marker:", e);
                }
              });
              window[`imei-details_${i}_google_markers`] = null;
            }

            if (overlayGroup && Array.isArray(overlayGroup)) {
              overlayGroup.forEach((overlay) => {
                try {
                  if (overlay && typeof overlay.setMap === "function") {
                    overlay.setMap(null);
                  }
                } catch (e) {
                  console.warn("Error clearing device overlay:", e);
                }
              });
              window[`imei-details_${i}_google_overlays`] = null;
            }
          }

          removeGoogleOverlays(`imei-details`);
        }
        if (trackMapRef) {
          removeGoogleOverlays(`track`);
        }
      } else if (mapProvider === "qiMap") {
        // Specific handling for `qiMap`
        mapRef &&
          mapRef.removeLayerSource &&
          mapRef.removeLayerSource(`imei-details_${selectedRow - 1}`);
        trackMapRef &&
          trackMapRef.removeLayerSource &&
          trackMapRef.removeLayerSource(`track_${deviceId}`);
        // Clear device label overlays when closing detail view
        clearQiMapDeviceLabels(mapRef);
      }
    } catch (error) {
      console.error("Error removing layers or overlays:", error);
    }
  };

  const removeRowSelection = () => {
    setHighlight(null);
    setSelectedRowId(null);
  };

  const { activeBoxes, addNewBox, removeBox, revertBox, isItemsDragging, handleDragChange } =
    useDndContainer();

  //Reset Map to Initial State
  const resetMapToInitialState = () => {
    setMapResetCount(mapResetCount + 1);
    setUserHasAdjustedMap(false);
    setCurrentMapZoom(null);
    setCurrentMapCenter(null);
    setInitialLoad(true);
    setWasVehicleSelected(false);
  };

  useEffect(() => {
    if (isTrackPointsHistoryDataCollected) {
      resetMapToInitialState();
    }
  }, [isTrackPointsHistoryDataCollected]);

  //Show Map
  const showMap = () => {
    setCurrentTab("Map");
    setShowTrack(false);
    // Only reset map state if no vehicle is selected (general tracking view)
    // Don't reset user interaction state when switching tabs
    // if (!deviceId) {
    //   setMapResetCount(mapResetCount + 1);
    //   setCurrentMapZoom(null);
    //   setCurrentMapCenter(null);
    //   setInitialLoad(true);
    //   setWasVehicleSelected(false);
    //   // Don't reset userHasAdjustedMap here - preserve user's interaction preference
    // }
    resetMapToInitialState();
  };
  //Show Live Track
  const showLiveTrack = () => {
    setCurrentTab("LiveTrack");
    setShowTrack(true);
  };

  //Show Activities
  const showActivities = () => {
    setCurrentTab("Activities");
    setShowTrack(true);
  };

  //Show Trips
  const showTrips = () => {
    setCurrentTab("Trips");
    setShowTrack(true);
  };

  //Show Events
  const showEvents = () => {
    setCurrentTab("Events");
    setShowTrack(true);
  };

  //Show Raw Data
  const showRawData = () => {
    setCurrentTab("RawData");
    setShowTrack(true);
  };

  //Show Graphs
  const showGraphs = () => {
    setCurrentTab("Graphs");
    setShowTrack(true);
  };

  //Show Trackpoints
  const showTrackpoints = () => {
    setCurrentTab("TrackPoints");
    setShowTrack(true);
  };

  //clear live track on type
  useEffect(() => {
    if (simpleSearch) {
      setShowTrack(false);
      setDeviceId(null);
      setDockAlign("cross");
      setHighlight(null);
      removeLayerOnClose();
    }
  }, [simpleSearch]);

  const [activitiesTimeRange, setActivitiesTimeRange] = useState(selectedRange);
  const [mapSelectionLoading, setMapSelectionLoading] = useState(false);
  const [refreshMap, setRefreshMap] = useState(false);
  //To set the total count of data in the list of activity and trips
  const [listCount, setListCount] = useState(0);

  useEffect(() => {
    setRefreshMap((prev) => !prev);
    setListCount(0);
  }, [selectedRange, currentTab]);

  // Add these new hooks
  const { page, perPage } = usePagination();

  const { data = { data: [], total_count: 0 } } = useGetPluginsQuery({
    page,
    per_page: perPage,
    order_by: "plugins.created_at",
    order_dir: "desc",
  });

  const addPlugins = data.data.filter(
    (plugin) =>
      plugin.tracker_containers.map((s) => parseInt(s, 10)).includes(2) && plugin.is_enabled,
  );
  const isPluginTab = addPlugins.some((plugin) => plugin.name === currentTab);
  const selectedPlugin = data.data.find((plugin) => plugin.name === currentTab);

  // Add this new function
  const showdetailsTabs = (tab) => {
    setShowDetails(false);
    setDockAlign("cross");
    setCurrentTab(tab);
  };

  useEffect(() => {
    if (currentTab) {
      console.log("before: currentTab", currentTab);
      dispatch(setCurrentTabGlobal(currentTab));
      console.log("after: currentTab", currentTab);
    }
  }, [currentTab]);

  useEffect(() => {
    dispatch(setGlobalResetCount(globalResetCount + 1));
  }, [deviceId, currentTab]);

  useEffect(() => {
    if (currentTab !== "Map" && !deviceId) {
      setCurrentTab("Map");
    }
  }, [currentTab, deviceId]);

  // Clear the Live data when deviceId changes
  useEffect(() => {
    // Check if we're transitioning from selected to deselected
    const wasSelected = prevSelectedVehiclePlateRef.current;
    const isNowDeselected = wasSelected && !deviceId;
    const isNewVehicleSelected = deviceId && deviceId !== wasSelected;

    setLiveTrackingData([]);
    setTrackpointsHistoryData([]);
    setStandstillData([]); // Reset standstill data when device changes
    dispatch(setLiveTrackData([]));
    setSelectedRangeLive({
      startDate: moment().subtract(trackpointsSelectedRange, "minutes"),
      endDate: moment(),
    });
    setIsTrackPointsHistoryDataCollected(false);

    // Only reset map adjustment tracking when selecting a NEW vehicle or deselecting
    // Don't reset when just switching tabs with the same vehicle
    if (isNewVehicleSelected || isNowDeselected) {
      setUserHasAdjustedMap(false);
      setCurrentMapZoom(null);
      setCurrentMapCenter(null);
      setIsInitialVehicleLoad(true);
    }

    // Track if we're transitioning from selected to deselected (for bounds fitting)
    setWasVehicleSelected(isNowDeselected);
    // Update ref for next comparison
    prevSelectedVehiclePlateRef.current = deviceId;
  }, [deviceId]);

  useEffect(() => {
    if (deviceId) {
      setLiveTime(
        moment().subtract(trackpointsSelectedRange, "minutes").format("DD/MM/YY - hh:mm:ss A"),
      );
    }
  }, [deviceId]);

  // Handle device deselection cleanup
  useEffect(() => {
    if (!deviceId) {
      // Device was deselected, clear the map and restore main view
      removeLayerOnClose();
      setselectedVehiclePlate(null);
      setselectedDeviceName(null);
      setHighlight(null);
      setSelectedRowId(null);
      setShowDetails(false);
      setDockAlign("cross");
    }
  }, [deviceId]);

  return (
    <>
      <main className="tracking-app-main-container item-list-right-layout">
        <article className={`tracking-app-main-container_block ${currentTab}`}>
          <DeviceList
            setDetails={setShowDetails}
            setDeviceId={setDeviceId}
            setSourceIds={setSourceIds}
            sourceIds={sourceIds}
            showPontOnMap={showPontOnMap}
            mapData={mapData}
            setselectedVehiclePlate={setselectedVehiclePlate}
            setselectedDeviceName={setselectedDeviceName}
            setHighlight={setHighlight}
            highlight={highlight}
            dockAlign={dockAlign}
            setDockAlign={setDockAlign}
            setShowDetails={setShowDetails}
            removeLayerOnClose={removeLayerOnClose}
            mapExpand={mapExpand}
            setMapExpand={setMapExpand}
            trackMapRef={trackMapRef}
            deviceId={deviceId}
            setShowTrack={setShowTrack}
            setSimpleSearch={setSimpleSearch}
            simpleSearch={simpleSearch}
            currentTab={currentTab}
            removeRowSelection={removeRowSelection}
            selectedRowId={selectedRowId}
            setSelectedRowId={setSelectedRowId}
            vehicleData={vehicleData}
            setVehicleData={setVehicleData}
            setCurrentTab={setCurrentTab}
            data={sortedDataDisplay && devicesData}
            totalCountVehicles={sortedDataDisplay && trackingData?.total_count}
            paginationVehicles={sortedDataDisplay && pagination}
            setPageVehicles={setPage1}
            sortedDataDisplay={sortedDataDisplay}
            setSortedDataDisplay={setSortedDataDisplay}
            q={q}
            setNonAdminUserId={setNonAdminUserId}
            nonAdminUserId={nonAdminUserId}
            addNewBox={addNewBox}
            isRefreshing={isRefreshing}
          />
          <div className="map-and-tabs-container">
            <header className="tracking-app-main-container_block_header">
              <HorizontalScroll className="map-view-tabs">
                {deviceId && (
                  <ul className="map-and-details_tabs">
                    <li>
                      <span
                        className={`map-and-details_tabs_item ${currentTab === "Map" && "active"}`}
                        onClick={showMap}
                      >
                        {getLocalizedString("live", "Live")}
                        <LiveStatusIndicator
                          data={
                            devicesData.find((device) => device.device_name_list === deviceId) ||
                            { device_name_list: deviceId }
                          }
                          cardType="Devices"
                          mapData={mapData}
                        />
                      </span>
                    </li>
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "LiveTrack" && "active"
                          }`}
                          onClick={() =>
                            deviceId
                              ? showLiveTrack()
                              : toast.error(
                                  getLocalizedString("no_device_selected", "No Device Selected"),
                                )
                          }
                        >
                          {getLocalizedString("history", "History")}
                        </span>
                      </li>
                    )}

                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Activities" && "active"
                          }`}
                          onClick={() =>
                            deviceId
                              ? showActivities()
                              : toast.error(
                                  getLocalizedString("no_device_selected", "No Device Selected"),
                                )
                          }
                        >
                          {getLocalizedString("activities", "Activities")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Trips" && "active"
                          }`}
                          onClick={() =>
                            deviceId
                              ? showTrips()
                              : toast.error(
                                  getLocalizedString("no_device_selected", "No Device Selected"),
                                )
                          }
                        >
                          {getLocalizedString("trips", "Trips")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Events" && "active"
                          }`}
                          onClick={() =>
                            deviceId
                              ? showEvents()
                              : toast.error(
                                  getLocalizedString("no_device_selected", "No Device Selected"),
                                )
                          }
                        >
                          {getLocalizedString("events", "Events")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "RawData" && "active"
                          }`}
                          onClick={() =>
                            deviceId
                              ? showRawData()
                              : toast.error(
                                  getLocalizedString("no_device_selected", "No Device Selected"),
                                )
                          }
                        >
                          {getLocalizedString("raw_data", "Raw Data")}
                        </span>
                      </li>
                    )}
                    {selectedRowId !== null && (
                      <li>
                        <span
                          className={`map-and-details_tabs_item ${
                            currentTab === "Graphs" && "active"
                          }`}
                          onClick={() =>
                            deviceId
                              ? showGraphs()
                              : toast.error(
                                  getLocalizedString("no_device_selected", "No Device Selected"),
                                )
                          }
                        >
                          {getLocalizedString("graphs", "Graphs")}
                        </span>
                      </li>
                    )}
                    {addPlugins &&
                      addPlugins.map((plugin, index) => (
                        <li key={index}>
                          <span
                            className={`map-and-details_tabs_item ${
                              currentTab === plugin.name && "active"
                            }`}
                            onClick={() => showdetailsTabs(plugin.name)}
                          >
                            {getLocalizedString("plugins", plugin.name)}
                          </span>
                        </li>
                      ))}
                  </ul>
                )}
              </HorizontalScroll>

              {currentTab === "Map" && deviceId && (
                <span className="trackpoints-selected-range">
                  <strong>
                    {getLocalizedString("since", "Since")} {liveTime}
                  </strong>
                </span>
              )}

              <QIAutoMapIndicator
                currentTab={currentTab}
                mapProvider={mapProvider}
                dataId={deviceId}
                trackingPoints={trackingPoints}
                userHasAdjustedMap={userHasAdjustedMap}
                resetMapToInitialState={resetMapToInitialState}
              />

              {/* Date Range Picker and Column Config Setting */}
              {(currentTab === "LiveTrack" || currentTab === "Map") && (
                <QICustomDateRangePicker
                  resetCount={resetCount}
                  selectedRange={selectedRangeHistory}
                  setSelectedRangeLocal={setSelectedRangeHistory}
                  localRange={true}
                  setResetCount={setResetCount}
                  openCalendar="left"
                  className={currentTab == "Map" ? "live" : ""}
                />
              )}

              {/* Date Range Picker for Trips Events Activities and Raw Data with 24 hrs default value*/}
              {(currentTab == "Trips" ||
                currentTab == "Activities" ||
                currentTab == "Events" ||
                currentTab == "RawData") && (
                <QICustomDateRangePicker
                  resetCount={globalResetCount}
                  selectedRange={selectedRange}
                  openCalendar="left"
                  preventAutoUpdate={true}
                />
              )}
            </header>

            <article
              className={`map-and-details ${dockAlign} ${
                maximizeMinimize ? "minimized-details" : ""
              }`}
            >
              {currentTab === "Map" ? (
                <VehicleMap
                  mapExpand={mapExpand}
                  mapRef={mapRef}
                  dockAlign={dockAlign}
                  setMapRef={setMapRef}
                  deviceId={deviceId}
                  selectedRowId={selectedRowId}
                  maximizeMinimize={maximizeMinimize}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  selectedVehiclePlate={selectedVehiclePlate}
                  mapPoint={mapPoint}
                  resetMapToInitialState={resetMapToInitialState}
                  statusData={devicesData}
                  showStatusCounts={!showDetails}
                />
              ) : currentTab === "LiveTrack" ? (
                <VehicleTrack
                  dockAlign={dockAlign}
                  deviceId={deviceId}
                  realTimeData={realTimedata[deviceId]}
                  setTrackMapRef={setTrackMapRef}
                  trackMapRef={trackMapRef}
                  mapExpand={mapExpand}
                  selectedRange={selectedRangeHistory}
                  setResetCount={setResetCount}
                  maximizeMinimize={maximizeMinimize}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  showTooltip={true}
                  selectedVehiclePlate={selectedVehiclePlate}
                  clientConfig={clientConfig}
                  trackingPoints={trackingPoints}
                  mapPoint={mapPoint}
                  type="Devices"
                />
              ) : currentTab === "TrackPoints" ? (
                <EventsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  mapPoint={mapPoint}
                  selectedRowId={deviceId}
                  setDockAlign={setDockAlign}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  showEventsDetails={showEventsDetails}
                />
              ) : currentTab === "Activities" ? (
                <TripsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  selectedRange={activitiesTimeRange}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  listCount={listCount}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  clientConfig={clientConfig}
                  mapSelectionLoading={mapSelectionLoading}
                />
              ) : currentTab === "Trips" ? (
                <TripsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  selectedRange={activitiesTimeRange}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  listCount={listCount}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  clientConfig={clientConfig}
                  mapSelectionLoading={mapSelectionLoading}
                />
              ) : currentTab === "Events" ? (
                <EventsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  mapPoint={mapPoint}
                  selectedRowId={deviceId}
                  setDockAlign={setDockAlign}
                  maximizeMinimize={maximizeMinimize}
                  refreshMap={refreshMap}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  showEventsDetails={showEventsDetails}
                />
              ) : isPluginTab ? (
                <PluginContainer selectedPlugin={selectedPlugin} />
              ) : null}
              {showDetails === true && currentTab !== "RawData" && currentTab !== "Graphs" && (
                <article className={`details-block`}>
                  <QIDragAndDropDetails
                    setDetails={setShowDetails}
                    setPopup={openDeviceModal}
                    setCurrentTab={setCurrentTab}
                    deviceData={deviceData || {}}
                    removeLayerOnClose={removeLayerOnClose}
                    selectedVehiclePlate={selectedDeviceName}
                    setSelectedVehiclePlate={setselectedVehiclePlate}
                    removeRowSelection={removeRowSelection}
                    setDockAlign={setDockAlign}
                    dockAlign={dockAlign}
                    deviceId={deviceId}
                    realTimedata={realTimedata}
                    setDeviceId={setDeviceId}
                    showTrack={showTrack}
                    setShowTrack={setShowTrack}
                    headerName={getLocalizedString("device_name", "Device Name")}
                    headerDetails={
                      <HeaderDetails
                        realTimedata={realTimedata}
                        deviceData={deviceData}
                        deviceId={deviceId}
                        type="Devices"
                      />
                    }
                    listDetails={
                      <ListDetails
                        clientConfig={clientConfig}
                        realTimedata={realTimedata}
                        deviceData={deviceData}
                        deviceId={deviceId}
                      />
                    }
                    currentTab={currentTab}
                    maximizeMinimize={maximizeMinimize}
                    setmaximizeMinimize={setmaximizeMinimize}
                    liveDetailsBlockView={liveDetailsBlockView}
                    setLiveDetailsBlockView={setLiveDetailsBlockView}
                    customContent={
                      currentTab === "Activities" ||
                      currentTab === "Trips" ||
                      currentTab === "Events" ||
                      currentTab === "TrackPoints" ||
                      currentTab === "LiveTrack" ||
                      (currentTab === "Map" && liveDetailsBlockView === "TrackPoints")
                        ? true
                        : false
                    }
                  >
                    {(currentTab === "Activities" ||
                      currentTab === "Trips" ||
                      currentTab === "Events") &&
                      selectedVehiclePlate && (
                        <SelectedAssetSummary
                          plateNumber={selectedVehiclePlate}
                          cardType="Devices"
                          variant="plate"
                        />
                      )}
                    {currentTab === "Activities" && (
                      <Activities
                        deviceId={deviceId}
                        selectedRange={selectedRange}
                        clientId={clientId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Devices"
                        setActivitiesTimeRange={setActivitiesTimeRange}
                        setListCount={setListCount}
                      />
                    )}
                    {currentTab === "Trips" && (
                      <TripsContainer
                        resetCount={resetCount}
                        setResetCount={setResetCount}
                        deviceId={deviceId}
                        selectedRange={selectedRange}
                        setSelectedRange={setSelectedRangeHistory}
                        clientId={clientId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Devices"
                        setActivitiesTimeRange={setActivitiesTimeRange}
                        setListCount={setListCount}
                        setMapSelectionLoading={setMapSelectionLoading}
                      />
                    )}
                    {currentTab === "Events" && (
                      <EventsContainer
                        resetCount={resetCount}
                        setResetCount={setResetCount}
                        deviceId={deviceId}
                        selectedRange={selectedRange}
                        setSelectedRange={setSelectedRangeHistory}
                        clientId={clientId}
                        selectedVehiclePlate={selectedVehiclePlate}
                        type="Devices"
                        setDeviceId={setDeviceId}
                        setDockAlign={setDockAlign}
                        setMapPoint={setMapPoint}
                        setShowEventsDetails={setShowEventsDetails}
                      />
                    )}

                    {currentTab === "Map" && (
                      <>
                        <LiveTrackPoints
                          deviceId={deviceId}
                          setDeviceId={setDeviceId}
                          liveData={realTimedata}
                          selectedVehiclePlate={selectedVehiclePlate}
                          selectedRange={selectedRangeLive}
                          setResetCount={setResetCount}
                          setMapPoint={setMapPoint}
                          setDockAlign={setDockAlign}
                          type="Devices"
                          currentTab={currentTab}
                          setSelectedTrackPointData={setSelectedTrackPointData}
                          setLiveDetailsBlockView={setLiveDetailsBlockView}
                          deviceData={deviceData}
                          setTrackpointsHistoryData={setTrackpointsHistoryData}
                          setIsTrackPointsHistoryDataCollected={
                            setIsTrackPointsHistoryDataCollected
                          }
                          selectedAsset={vehicleData}
                          mapData={mapData}
                          summaryCardType="Devices"
                        />
                      </>
                    )}
                    {currentTab === "LiveTrack" && (
                      <>
                        <HistoryTrackPoints
                          deviceId={deviceId}
                          setDeviceId={setDeviceId}
                          liveData={realTimedata}
                          selectedVehiclePlate={selectedVehiclePlate}
                          selectedRange={selectedRangeHistory}
                          setResetCount={setResetCount}
                          setMapPoint={setMapPoint}
                          setDockAlign={setDockAlign}
                          type="Devices"
                          currentTab={currentTab}
                          setSelectedTrackPointData={setSelectedTrackPointData}
                          setLiveDetailsBlockView={setLiveDetailsBlockView}
                          deviceData={deviceData}
                          setTrackpointsHistoryData={setTrackpointsHistoryData}
                          setStandstillData={setStandstillData}
                          selectedAsset={vehicleData}
                          mapData={mapData}
                          summaryCardType="Devices"
                        />
                      </>
                    )}
                  </QIDragAndDropDetails>
                </article>
              )}
            </article>
            {currentTab === "RawData" && (
              <>
                <section className="tracking-app-main-container_block_header_secondary has-plate-summary">
                  {selectedVehiclePlate && (
                    <SelectedAssetSummary
                      plateNumber={selectedVehiclePlate}
                      cardType="Devices"
                      variant="plate"
                    />
                  )}
                  {/* Date Range Picker and Column Config Setting */}
                  <div className="raw-data-section">
                    <>
                      <QISwitch
                        label="Decode"
                        value={decode}
                        onChange={(value) => {
                          setDecode((prev) => !prev);
                        }}
                        title={
                          decode
                            ? getLocalizedString(
                                "data_will_be_blank_if_format_is_binary",
                                "Data will be blank if format is binary",
                              )
                            : getLocalizedString(
                                "data_will_be_displayed_in_base64encoded_format",
                                "Data will be displayed in base64encoded format",
                              )
                        }
                        disabled={false}
                        readOnly={false}
                      />

                      <QISwitch
                        label={order ? "Asec" : "Desc"}
                        value={order}
                        onChange={(value) => {
                          setOrder((prev) => !prev);
                        }}
                        title={""}
                        disabled={false}
                        readOnly={false}
                      />
                    </>
                  </div>
                </section>
                <RawData
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  decode={decode}
                  order={order}
                />
              </>
            )}
            {currentTab === "Graphs" && (
              <GraphsContainer
                deviceId={deviceId}
                selectedVehiclePlate={selectedVehiclePlate}
                type="Devices"
              />
            )}
          </div>
        </article>
      </main>

      {dockAlign === "pop-out" && (
        <Dnd
          layoutName="trackingLayout"
          isItemsDragging={isItemsDragging}
          handleDragChange={handleDragChange}
          setDetails={setShowDetails}
        >
          {Object.keys(activeBoxes).map((key) => (
            <WindowTab
              id={key}
              {...activeBoxes[key].props}
              onClose={removeBox}
              onMinimise={revertBox}
              setShowDetails={setShowDetails}
              setDockAlign={setDockAlign}
              setDeviceId={setDeviceId}
              setShowTrack={setShowTrack}
              selectedVehiclePlate={selectedDeviceName}
              headerName={getLocalizedString("device_name", "Device Name")}
              setHighlight={setHighlight}
              removeLayerOnClose={removeLayerOnClose}
              removeRowSelection={removeRowSelection}
            >
              {(currentTab === "Activities" || currentTab === "Trips" || currentTab === "Events") &&
                selectedVehiclePlate && (
                  <SelectedAssetSummary
                    plateNumber={selectedVehiclePlate}
                    cardType="Devices"
                    variant="plate"
                  />
                )}
              {currentTab === "Activities" ? (
                <Activities
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  clientId={clientId}
                  selectedVehiclePlate={selectedVehiclePlate}
                  type="Devices"
                />
              ) : currentTab === "Trips" ? (
                <TripsContainer
                  resetCount={globalResetCount}
                  setResetCount={setGlobalResetCount}
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  setSelectedRange={setSelectedRangeHistory}
                  clientId={clientId}
                  selectedVehiclePlate={selectedVehiclePlate}
                  type="Devices"
                />
              ) : currentTab === "Events" ? (
                <EventsContainer
                  resetCount={globalResetCount}
                  setResetCount={setGlobalResetCount}
                  deviceId={deviceId}
                  selectedRange={selectedRange}
                  setSelectedRange={setSelectedRangeHistory}
                  clientId={clientId}
                  selectedVehiclePlate={selectedVehiclePlate}
                  type="Devices"
                  setDeviceId={setDeviceId}
                  setDockAlign={setDockAlign}
                  setMapPoint={setMapPoint}
                  setShowEventsDetails={setShowEventsDetails}
                />
              ) : currentTab === "TrackPoints" ||
                currentTab === "LiveTrack" ||
                (currentTab === "Map" && liveDetailsBlockView === "TrackPoints") ? (
                <>
                  {toggleTrackPointTab ? (
                    <RawData
                      deviceId={deviceId}
                      selectedRange={selectedRange}
                      decode={decode}
                      order={order}
                    />
                  ) : currentTab === "Map" ? (
                    <LiveTrackPoints
                      deviceId={deviceId}
                      liveData={realTimedata}
                      selectedVehiclePlate={selectedVehiclePlate}
                      selectedRange={selectedRangeLive}
                      setResetCount={setResetCount}
                      type="Devices"
                      currentTab={currentTab}
                      setSelectedTrackPointData={setSelectedTrackPointData}
                      setLiveDetailsBlockView={setLiveDetailsBlockView}
                      deviceData={deviceData}
                      setTrackpointsHistoryData={setTrackpointsHistoryData}
                      setIsTrackPointsHistoryDataCollected={setIsTrackPointsHistoryDataCollected}
                      selectedAsset={vehicleData}
                      mapData={mapData}
                      summaryCardType="Devices"
                    />
                  ) : (
                    <HistoryTrackPoints
                      deviceId={deviceId}
                      setDeviceId={setDeviceId}
                      liveData={realTimedata}
                      selectedVehiclePlate={selectedVehiclePlate}
                      selectedRange={selectedRangeHistory}
                      setResetCount={setResetCount}
                      setMapPoint={setMapPoint}
                      setDockAlign={setDockAlign}
                      type="Devices"
                      currentTab={currentTab}
                      setSelectedTrackPointData={setSelectedTrackPointData}
                      setLiveDetailsBlockView={setLiveDetailsBlockView}
                      deviceData={deviceData}
                      setTrackpointsHistoryData={setTrackpointsHistoryData}
                      setStandstillData={setStandstillData}
                      selectedAsset={vehicleData}
                      mapData={mapData}
                      summaryCardType="Devices"
                    />
                  )}
                </>
              ) : isPluginTab ? (
                <PluginContainer selectedPlugin={selectedPlugin} />
              ) : (
                <VehicleDetailsWindowView
                  realTimedata={realTimedata}
                  deviceId={deviceId}
                  deviceData={deviceData}
                  clientConfig={clientConfig}
                  summaryDetails={
                    <HeaderDetails
                      realTimedata={realTimedata}
                      deviceData={deviceData}
                      deviceId={deviceId}
                      type="Devices"
                    />
                  }
                  listDetails={
                    <ListDetails
                      clientConfig={clientConfig}
                      realTimedata={realTimedata}
                      deviceData={deviceData}
                      deviceId={deviceId}
                    />
                  }
                />
              )}
            </WindowTab>
          ))}
        </Dnd>
      )}
      <ToastContainer />
    </>
  );
};
